import React from 'react';
import ControlPanel from './views/controlpanel';

function App() {
  return (
    <ControlPanel />
  );
}

export default App;
